import { createTranslationResource } from '@backstage/core-plugin-api/alpha';
import { gitlabTranslationRef } from '@immobiliarelabs/backstage-plugin-gitlab';

export const gitlabTranslations = createTranslationResource({
  ref: gitlabTranslationRef,
  translations: {
    'pt-BR': () => import('./pt-BR'),
  },
});
